import {
  fetchV1Roles,
  searchV1Roles,
  createV1Role,
  deleteV1Role,
  fetchV1Permissions,
  searchV1Permissions,
} from "@/services/v1/userAPIService";

export default {
  state: {
    roles: [],
    permissions: [],
    rolePageSize: 5,
    permissionPageSize: 5,
    totalRoleCount: 0,
    totalPermissionCount: 0,
    searchPermissionQuery: "",
    searchRoleQuery: ""
  },
  getters: {
    roles: (state) => state.roles,
    permissions: (state) => state.permissions,
    currentRolePageSize: (state) => state.rolePageSize,
    currentPermissionPageSize: (state) => state.permissionPageSize,
    totalRoleCount: (state) => state.totalRoleCount,
    totalPermissionCount: (state) => state.totalPermissionCount,
    searchPermissionQuery: (state) => state.searchPermissionQuery,
    searchRoleQuery: (state) => state.searchRoleQuery,
  },
  mutations: {
    SET_ROLES(state, roles) {
      state.roles = roles;
    },
    REMOVE_ROLE(state, roleId) {
      state.roles = state.roles.filter((role) => role.id !== roleId);
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
    SET_ROLE_PAGE_SIZE(state, rolePageSize) {
      state.rolePageSize = rolePageSize;
    },
    SET_PERMISSION_PAGE_SIZE(state, permissionPageSize) {
      state.permissionPageSize = permissionPageSize;
    },
    SET_TOTAL_ROLE_COUNT(state, totalRoleCount) {
      state.totalRoleCount = totalRoleCount;
    },
    DECREASE_ROLE_COUNT(state) {
      state.totalRoleCount -= 1;
    },
    SET_TOTAL_PERMISSION_COUNT(state, totalPermissionCount) {
      state.totalPermissionCount = totalPermissionCount;
    },
    SET_PERMISSION_SEARCH_QUERY(state, query) {
      state.searchPermissionQuery = query;
    },
    SET_ROLE_SEARCH_QUERY(state, query) {
      state.searchRoleQuery = query;
    },
  },
  actions: {
    async fetchRoles({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Roles(page, pageSize);
        commit("SET_ROLES", response.results);
        commit("SET_ROLE_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_ROLE_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching books:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async searchRoles({ commit }, { query, page = 1, pageSize = 8 } = {}) {
      commit("SET_ROLE_SEARCH_QUERY", query);
      try {
        const response = await searchV1Roles(query, page, pageSize);
        commit("SET_ROLES", response.results);
        commit("SET_ROLE_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_ROLE_COUNT", response.count);
      } catch (error) {
        console.error("Error searching roles:", error);
      }
    },
    async addRole({ commit }, role) {
      try {
        const response = await createV1Role(role);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`role create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message = error.response?.data?.message || "Failed to add role.";
        return { success: false, message };
      }
    },
    async deleteRole({ commit }, id) {
      try {
        const response = await deleteV1Role(id);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        commit("DECREASE_ROLE_COUNT");
        commit("REMOVE_ROLE", id);
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`role delete... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to delete role.";
        return { success: false, message };
      }
    },
    async fetchPermissions({ commit }, { page = 1, pageSize = 5 } = {}) {
      try {
        const response = await fetchV1Permissions(page, pageSize);
        commit("SET_PERMISSIONS", response.results);
        commit("SET_PERMISSION_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_PERMISSION_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching permissions:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async searchPermissions(
      { commit },
      { query, page = 1, pageSize = 8 } = {}
    ) {
      commit("SET_PERMISSION_SEARCH_QUERY", query);
      try {
        const response = await searchV1Permissions(query, page, pageSize);
        commit("SET_PERMISSIONS", response.results);
        commit("SET_PERMISSION_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_PERMISSION_COUNT", response.count);
      } catch (error) {
        console.error("Error searching permissions:", error);
      }
    },
  },
};
